import React, { useState, useEffect } from "react";
import AddImage from "../../assets/images/AddImage.jpg";
import EP1 from "../../assets/images/EP1.jpg";
import EP2 from "../../assets/images/EP2.jpg";
import EP3 from "../../assets/images/EP3.jpg";
import search from "../../assets/svg/search.svg";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/Hooks/ScrollToTop";
import SmallHeader from "../../components/Small_Header/SmallHeader";
import styles from "./Explore.module.scss";
import ExploreYourMind from "./ExploreYourMind";
import ExploreYourWorld from "./ExploreYourWorld";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleLeft } from "react-icons/fa6";
import axios from "../../components/Hooks/axios";
import DefaultProfilePic from "../../assets/images/user.png";
import { setCookies } from "../../components/Hooks/setCookies";
import Avatar from "../../components/Avatar/Avatar";

const Explore = () => {
	const [Travel, setTravel] = useState(false);
	const [Funny, setFunny] = useState(false);
	const [Photography, setPhotography] = useState(false);
	const [News, setNews] = useState(false);
	const [Pets, setPets] = useState(false);
	const [RoadTrip, setRoadTrip] = useState(false);
	const { userId, token } = useSelector((state) => state.auth);
	const [userData, setUserData] = useState([]);
	const [posts, setPosts] = useState([]);
	const [searchQuery, setSearchQuery] = useState("");
	const [isSearching, setIsSearching] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 431);
	const [showSearchRight, setShowSearchRight] = useState(true);
	const navigate = useNavigate()

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 431);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);


	const fetchInitialData = () => {
		axios
			.get("/post/following?skip=0&limit=50")
			.then(({ data }) => {
				const allPosts = data?.AllPost || [];
				// Strict Image-Only Filter: Ensure media exists and is not a video
				const imageOnlyPosts = allPosts.filter(post => {
					const firstMedia = Array.isArray(post.mediaUrl) ? post.mediaUrl[0] : post.mediaUrl;
					const mediaPath = typeof firstMedia === 'string' ? firstMedia : firstMedia?.url;
					const isVideo = mediaPath?.toLowerCase().match(/\.(mp4|mov|wmv|avi|flv|mkv)$/);
					return mediaPath && !isVideo && !mediaPath.includes('undefined');
				});
				setPosts(imageOnlyPosts);
			})
			.catch((err) => console.log(err));

		axios
			.get(`/auth/randomUser`)
			.then(({ data }) => {
				setUserData(data || []);
			})
			.catch((error) => {
				console.log("Error => ", error);
			});
	};

	useEffect(() => {
		fetchInitialData();
	}, []);

	const performSearch = () => {
		if (searchQuery.trim() !== "") {
			setIsSearching(true);
			// Search for users
			axios.get(`/auth/userSearch?search=${searchQuery}`)
				.then(({ data }) => {
					const foundUsers = data || [];
					
					if (foundUsers.length > 0) {
						// Prioritize found users in the avatar row
						setUserData(prevUsers => {
							const otherUsers = prevUsers.filter(u => !foundUsers.some(fu => fu._id === u._id));
							return [...foundUsers, ...otherUsers];
						});

						// Get posts for the first found user
						const searchedUserId = foundUsers[0]._id;
						axios.get(`/post/${searchedUserId}`)
							.then(({ data: postData }) => {
								const userPosts = Array.isArray(postData) ? postData : (postData?.posts || []);
								// Strict Image-Only Filter
								const userImagePosts = userPosts.filter(post => {
									const firstMedia = Array.isArray(post.mediaUrl) ? post.mediaUrl[0] : post.mediaUrl;
									const mediaPath = typeof firstMedia === 'string' ? firstMedia : firstMedia?.url;
									const isVideo = mediaPath?.toLowerCase().match(/\.(mp4|mov|wmv|avi|flv|mkv)$/);
									return mediaPath && !isVideo && !mediaPath.includes('undefined');
								});

								// Prepend searched user posts to feed
								setPosts(prevPosts => {
									const filteredPrev = prevPosts.filter(p => !userImagePosts.some(up => up._id === p._id));
									return [...userImagePosts, ...filteredPrev];
								});
							})
							.catch(err => {
								console.error("Error fetching user posts:", err);
							});
					}
				})
				.catch(err => {
					console.error("Error searching users:", err);
				});
		} else {
			setIsSearching(false);
			fetchInitialData();
		}
	};

	const handleSearch = (e) => {
		if (e.key === "Enter") {
			performSearch();
		}
	};
	return (
		<div className="App">
			<div className="MainContainer">
				<ScrollToTop />
				{isMobile ? null : <Header />}
				<div className={`${styles.Container} ${styles.Explore}`}>
					<div className={styles.TopRow}>
						<div className={styles.BackButton}>
							<button onClick={() => { navigate('/Home') }}>
								<FaAngleLeft />
							</button>
						</div>
						<SmallHeader hideNotification={true} hideSearch={true} />
					</div>


					<div className={styles.ExploreHeader}>
						<div className={styles.HeadingPart}>
							<h1>Explore your World</h1>
						</div>
						{isMobile ? null : (
							<div className={styles.SearchPart}>
								<div className={styles.InputContainer}>
									<input
										type="text"
										placeholder="Search"
										className={showSearchRight ? styles.active : ""}
										value={searchQuery}
										onChange={(e) => setSearchQuery(e.target.value)}
										onKeyDown={handleSearch}
									/>
									<img
										src={search}
										alt=""
										onClick={() => {
											if (showSearchRight && searchQuery.trim() !== "") {
												performSearch();
											} else {
												setShowSearchRight(!showSearchRight);
											}
										}}
										style={{ cursor: "pointer" }}
									/>
								</div>
							</div>
						)}
					</div>

					<div className={styles.ExploreContainer}>

						<div className={styles.ExploreLeft}>


							<div className={styles.ExploreUserRow}>
								{userData?.map((user, index) => (
									<div
										key={index}
										className={styles.UserCircle}
										onClick={() => {
											const targetId = user._id || user.id;
											if (targetId) {
												setCookies({
													url: `${process.env.REACT_APP_TEMPLATE_BASE_URL}`,
													token,
													personaUserId: targetId,
													currentUserId: userId,
												});
											}
										}}
									>
										<div className={styles.UserImageWrapper}>
											<Avatar
												src={user.ProfilePic || user.personaThumbnail}
												name={user.username || user.displayName || user.GetstatedName || user.businessName || "User"}
												style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", fontSize: "4rem" }}
											/>
										</div>
										<span>{user.username || user.displayName || user.GetstatedName || user.businessName || "User"}</span>
									</div>
								))}
							</div>
							<ExploreYourWorld posts={posts} />
							<ExploreYourMind posts={posts} />
						</div>

						{isMobile ? null : (
							<div className={styles.ExploreRight}>
								<div className={styles.TagContainer}>
									<p>Tags For you</p>
									<div className={styles.btnContainer}>
										<button
											type="button"
											style={{ background: Travel ? "#3A0DBB" : "", color: Travel ? "#fff" : "" }}
											onClick={() => setTravel(!Travel)}>
											Travel
										</button>
										<button
											type="button"
											style={{ background: Funny ? "#3A0DBB" : "", color: Funny ? "#fff" : "" }}
											onClick={() => setFunny(!Funny)}>
											Funny
										</button>
										<button
											type="button"
											style={{ background: Photography ? "#3A0DBB" : "", color: Photography ? "#fff" : "" }}
											onClick={() => setPhotography(!Photography)}>
											Photography
										</button>
										<button
											type="button"
											style={{ background: News ? "#3A0DBB" : "", color: News ? "#fff" : "" }}
											onClick={() => setNews(!News)}>
											News
										</button>
										<button
											type="button"
											style={{ background: Pets ? "#3A0DBB" : "", color: Pets ? "#fff" : "" }}
											onClick={() => setPets(!Pets)}>
											Pets
										</button>
										<button
											type="button"
											style={{ background: RoadTrip ? "#3A0DBB" : "", color: RoadTrip ? "#fff" : "" }}
											onClick={() => setRoadTrip(!RoadTrip)}>
											RoadTrip
										</button>
									</div>
								</div>
								<div className={styles.ScrollCont}>
									<div className={styles.AddContainer}>
										<img src={AddImage} alt="" />
									</div>
									<div className={styles.LikeContainer}>
										<p>You may like</p>
										<div className={styles.LikeImages}>
											{posts.map((item, index) => (
												<img
													key={index}
													src={Array.isArray(item?.mediaUrl)
														? (typeof item.mediaUrl[0] === 'string' ? item.mediaUrl[0] : item.mediaUrl[0]?.url)
														: item?.mediaUrl}
													alt="post"
													onClick={() => navigate(`/Post/${item?._id}`)}
													style={{ cursor: "pointer" }}
													onError={(e) => { e.target.style.display = 'none' }}
												/>
											))}
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Explore;


